import * as ng from 'angular';
import { ValidationService } from '../../../services/validation.service';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { googleAPI } from '../../../third/googleAPI';

export class SummaryController implements ng.IController {

    static $inject: string[] = [
        '$state',
        '$scope',
        'store',
        'ArchiSmallServices',
        '$rootScope',
        '$uibModal'
    ];

    constructor(
        private $state: ng.ui.IStateService,
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $rootScope: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {
        $scope.user = store.get('registeringUser');
        $scope.registeredUser = store.get('registeredUser');
        let currentStepName = 'summary';

        if ($scope.registeredUser === undefined) {
            if ($scope.user === undefined) {
                $state.go('login');
                return;
            } else {
                $state.go('registration.registration-type');
            }
        }

        switch ($scope.registeredUser.accountData.userType) {
            case 1:
                $scope.pageHeader = 'Registrazione Libero Professionista';
                $scope.pageSubHeader = 'Termine e riepilogo';
                break;
            case 2:
                $scope.pageHeader = 'Registrazione Ditta Individuale';
                $scope.pageSubHeader = 'Termine e riepilogo';
                break;
            case 3:
                $scope.pageHeader = 'Registrazione Azienda';
                $scope.pageSubHeader = 'Termine e riepilogo';
                break;
        }

        $scope.dob = (dateValue) => {
            try {
                if (dateValue !== '') {
                    let date = new Date(dateValue);
                    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
                }
            } catch (err) {
                // ?
            }
            return dateValue;
        };
        $scope.next = () => {
            store.remove('registeredUser');
            store.remove('registrationJWT');
            $state.go('login');
        };
        $scope.printPage = (divName) => {
            $scope.printElement(document.getElementById(divName));
        };

        $scope.printElement = (elem) => {
            let domClone = elem.cloneNode(true);
            let printSection = document.getElementById('printSection');
            if (!printSection) {
                printSection = document.createElement('div');
                printSection.id = 'printSection';
                document.body.appendChild(printSection);
            }
            printSection.appendChild(domClone);
            window.print();
            printSection.innerHTML = '';
        };

        $scope.resendActivationEmail = () => {
            ArchiSmallServices.resendActivationMail($scope.registeredUser.accountData.email)
                .then((response: any) => {
                    $scope.emailSent = true;
                    let modalInstance = $uibModal.open({
                        component: 'activationMailSentModalComponent',
                        windowClass: 'center-modal'
                    });
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };

        let showErrorIfTokenExpired = () => {
            $rootScope.alert('warning', 'Hai completato correttamente la registrazione ad ArchiSMALL. ' +
                'Per scaricare il tuo Contratto ArchiSMALL firmato, usa le tue credenziali di accesso e vai nella Gestione Profilo.');
        };

        $scope.downloadFile = (path) => {
            ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
                .then((response: any) => {
                    if (response.expires_in > 60) {
                        $rootScope.downloadFile(path);
                    } else {
                        showErrorIfTokenExpired();
                    }
                }, (error) => {
                    showErrorIfTokenExpired();
                });
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/summary/summary.controller.ts